"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getFontFamily(fontName) {
  return "Font-".concat(fontName || 'Default');
}

var _default = getFontFamily;
exports.default = _default;